import { useState as m, useLayoutEffect as n } from "react";
import { u as i } from "./media-query.B9bznea_.js";
const p = () => {
  const [a, e] = m("large"), s = i("(min-width: 768px)"), t = i("(min-width: 1040px)"), r = i("(min-width: 1440px)"), o = i("(min-width: 1680px)");
  return n(() => {
    e(o ? "xx-large" : r ? "x-large" : t ? "large" : s ? "medium" : "small");
  }, [o, r, t, s]), a;
};
export {
  p as u
};
//# sourceMappingURL=viewport-size.DKLty78u.js.map
